import React from "react";
import "./Footer.css";
import { useTranslation } from "react-i18next";
import { MdEmail, MdPhone } from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa";

const Footer = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  // WhatsApp numbers (international format, no spaces or leading zeros)
  const whatsappNumbers = [
    { display: "03 973 983", number: "9613973983" },
    { display: "76 837 572", number: "96176837572" }
  ];

  return (
    <footer className="site-footer container" role="contentinfo">
      <div className="footer-grid">

        {/* Column 1 — Brand */}
        <div>
          <h4 className="footer-title">
            {isArabic ? (
              <>
                إنفينيت<br />بيروت الدولية
              </>
            ) : (
              t("Footer Brand", "Infinite Beirut International")
            )}
          </h4>

          <p className="muted">
            {isArabic
              ? "صلة الوصل بين الزبون وطلبه في كافة أنحاء العالم"
              : t("Footer Description", "Connecting buyers and sellers across the Arab world.")
            }
          </p>
        </div>

        {/* Column 2 — Links */}
        <div>
          <h4 className="footer-subtitle">
            {t("Footer Quick Links", "Quick links")}
          </h4>

          <ul className="footer-links muted">
            <li><a href="/">{t("Footer Link Home")}</a></li>
            <li><a href="/countries">{t("Footer Link Countries")}</a></li>
            <li><a href="/categories">{t("Footer Link Categories")}</a></li>
            <li><a href="/places">{t("Footer Link Search")}</a></li>
            <li><a href="/ads">{t("Footer Link Ads", "Ads")}</a></li>
            <li><a href="/about">{t("Footer Link About")}</a></li>
            {/* <li><a href="/contact">{t("Footer Link Contact")}</a></li> */}
            <li><a href="/post">{t("Footer Link Post Ad")}</a></li>
          </ul>
        </div>

        {/* Column 3 — Contact */}
        <div>
          <h4 className="footer-subtitle">{t("Footer Contact", "Contact")}</h4>

          <p className="muted">
            <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <MdEmail style={{ fontSize: "18px" }} />
              {t("Footer Email Label", "email")}:{" "}
              <a href="mailto:info@infinitelb.com" style={{ color: "inherit" }}>
                info@infinitelb.com
              </a>
            </span>
            <br />
            {/* <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <MdPhone style={{ fontSize: "18px" }} />
              {t("Footer Phone Label", "Phone")}:{" "}
              <a
                href="tel:+9611234567"
                style={{ color: "inherit", direction: "ltr", unicodeBidi: "plaintext" }}
              >
                +961 76 837 572
              </a>
            </span> */}
            <br />
            {/* WhatsApp numbers */}
            {whatsappNumbers.map((wp, idx) => (
              <span
                key={wp.number}
                style={{ display: "flex", alignItems: "center", gap: "6px", marginTop: 4 }}
              >
                <FaWhatsapp style={{ fontSize: "18px", color: "#25D366" }} />
                <a
                  href={`https://wa.me/${wp.number}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#25D366", fontWeight: "bold", textDecoration: "none",direction: "ltr" }}
                >
                  {wp.display}
                </a>
              </span>
            ))}
            <br />
            {/* {t("Footer Follow Text", "Follow us on social media")} */}
          </p>
        </div>

      </div>
      {/* Copyright */}
      <div
        className={`footer-copyright muted ${isArabic ? "rtl" : "ltr"}`}
        style={{
          textAlign: "center",
          marginTop: "24px",
          fontSize: "14px",
          direction: isArabic ? "rtl" : "ltr"
        }}
      >
        © {new Date().getFullYear()} {t("Footer Brand", "Infinite Beirut International")}. {t("Footer CreatedBy", "Created by Ali Naim & Ahmad Raychouni")}
      </div>
    </footer>
  );
};

export default Footer;